module.exports = __webpack_public_path__ + "media/images/facebook_logo-30c8674b9023e27328129d4be9f2f0e1.png";